export const ELIGIBILITY_STATUS = {
  APPROVED: 'approved',
  DENIED: 'denied',
  PENDING: 'pending',
} as const;
export type EligibilityStatus = (typeof ELIGIBILITY_STATUS)[keyof typeof ELIGIBILITY_STATUS];

export const CRITERION_TYPES = {
  INCLUSION: 'inclusion',
  EXCLUSION: 'exclusion',
} as const;
export type CriterionType = (typeof CRITERION_TYPES)[keyof typeof CRITERION_TYPES];

export const CHECK_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  CO_INVESTIGATOR: 'co_investigator',
} as const;
export type CheckType = (typeof CHECK_TYPES)[keyof typeof CHECK_TYPES];
